document.addEventListener("DOMContentLoaded", () => {

    /*=========================================
      GALLERY
    =========================================*/

    const thumbs = [...document.querySelectorAll(".hgp-thumb")];
    const slides = [...document.querySelectorAll(".hero-slide")];

    const prev = document.querySelector(".hero-prev");
    const next = document.querySelector(".hero-next");

    const thumbContainer = document.querySelector(".hgp-thumbnail-list");
    const thumbUp = document.querySelector(".thumb-up");
    const thumbDown = document.querySelector(".thumb-down");

    const hero = document.querySelector(".hgp-hero");

    function updateHeroMediaType(slide) {
        hero?.classList.toggle(
            "is-video",
            Boolean(slide?.querySelector("video"))
        );
    }

    let current = 0;

    function showSlide(index) {

        if (!slides.length) return;

        if (index < 0) {
            index = slides.length - 1;
        }

        if (index >= slides.length) {
            index = 0;
        }

        slides.forEach(slide => {

            slide.classList.remove("active");

            const video = slide.querySelector("video");

            if (video) {
                video.pause();
                video.currentTime = 0;
            }

        });


        /* Remove thumbnail active state only if thumbnails exist */
        thumbs.forEach(t => {
            t.classList.remove("active");
        });


        /* Activate slide */
        slides[index].classList.add("active");

        updateHeroMediaType(slides[index]);


        /* Activate thumbnail only when available */
        if (thumbs[index]) {
            thumbs[index].classList.add("active");
        }


        current = index;


        /* Play active video */
        const activeVideo =
            slides[index].querySelector("video");

        if (activeVideo) {
            activeVideo.play().catch(() => { });
        }


        /* Scroll thumbnail only when thumbnails exist */
        if (thumbs[index]) {
            thumbs[index].scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }

    }

    updateHeroMediaType(slides[current]);

    const viewVideoBtn = document.querySelector(".view-video-btn");

    viewVideoBtn?.addEventListener("click", () => {

        const videoIndex = slides.findIndex(slide =>
            slide.querySelector("video")
        );

        if (videoIndex !== -1) {

            showSlide(videoIndex);

            const video = slides[videoIndex].querySelector("video");

            video.currentTime = 0;
            video.play();

        }

    });

    thumbs.forEach((thumb, index) => {

        thumb.addEventListener("click", () => {

            showSlide(index);

        });

    });

    prev?.addEventListener("click", () => {

        showSlide(current - 1);

    });

    next?.addEventListener("click", () => {

        showSlide(current + 1);

    });

    function updateThumbButtons() {

        if (!thumbContainer) return;

        if (thumbUp) {

            thumbUp.disabled = thumbContainer.scrollTop <= 0;

        }

        if (thumbDown) {

            thumbDown.disabled =
                thumbContainer.scrollTop + thumbContainer.clientHeight >=
                thumbContainer.scrollHeight - 2;

        }

    }

    thumbUp?.addEventListener("click", () => {

        thumbContainer.scrollBy({

            top: -220,

            behavior: "smooth"

        });

    });

    thumbDown?.addEventListener("click", () => {

        thumbContainer.scrollBy({

            top: 220,

            behavior: "smooth"

        });

    });

    if (thumbContainer) {

        thumbContainer.addEventListener("wheel", (e) => {

            e.preventDefault();

            thumbContainer.scrollTop += e.deltaY;

        }, { passive: false });

        thumbContainer.addEventListener("scroll", updateThumbButtons);

        updateThumbButtons();

    }

    /*=========================================
      ACCORDION
    =========================================*/

    /*=========================================
      ACCORDION
    =========================================*/

    const accordionHeaders =
        document.querySelectorAll(".accordion-header");

    accordionHeaders.forEach(header => {

        header.addEventListener("click", (event) => {

            // Prevent browser focus/scroll behaviour
            event.preventDefault();

            const currentItem =
                header.closest(".accordion-item");

            if (!currentItem) return;

            const wasActive =
                currentItem.classList.contains("active");

            // Close all other accordions
            document
                .querySelectorAll(".accordion-item")
                .forEach(item => {

                    if (item !== currentItem) {

                        item.classList.remove("active");

                        const icon =
                            item.querySelector(".accordion-icon");

                        if (icon) {
                            icon.textContent = "+";
                        }

                    }

                });

            // Toggle current accordion
            currentItem.classList.toggle(
                "active",
                !wasActive
            );

            const icon =
                header.querySelector(".accordion-icon");

            if (icon) {

                icon.textContent =
                    !wasActive ? "−" : "+";

            }

            // Remove focus so browser cannot reposition page
            header.blur();

        });

    });


    /*=========================================
  FAQ ACCORDION
=========================================*/

    const faqItems =
        document.querySelectorAll(".faq-item");


    faqItems.forEach(item => {

        const question =
            item.querySelector(".faq-question");

        const icon =
            item.querySelector(".faq-icon");


        question?.addEventListener("click", () => {

            const isActive =
                item.classList.contains("active");


            /* Close all other FAQ items */

            faqItems.forEach(otherItem => {

                otherItem.classList.remove("active");

                const otherQuestion =
                    otherItem.querySelector(".faq-question");

                const otherIcon =
                    otherItem.querySelector(".faq-icon");


                otherQuestion?.setAttribute(
                    "aria-expanded",
                    "false"
                );


                if (otherIcon) {

                    otherIcon.textContent = "+";

                }

            });


            /* Open clicked FAQ */

            if (!isActive) {

                item.classList.add("active");

                question.setAttribute(
                    "aria-expanded",
                    "true"
                );


                if (icon) {

                    icon.textContent = "−";

                }

            }

        });

    });

    /*=========================================
      QUANTITY
    =========================================*/

    const qtyInput =
        document.getElementById("quantity");

    const minus =
        document.querySelector(".qty-minus");

    const plus =
        document.querySelector(".qty-plus");

    minus?.addEventListener("click", () => {

        let value = parseInt(qtyInput.value);

        if (value > 1) {

            qtyInput.value = value - 1;

        }

    });

    plus?.addEventListener("click", () => {

        let value = parseInt(qtyInput.value);

        qtyInput.value = value + 1;

    });

    qtyInput?.addEventListener("change", () => {

        if (qtyInput.value < 1) {

            qtyInput.value = 1;

        }

    });





    /*=========================================
      PRICE + VARIANT LOGIC
    =========================================*/

    const sellingPrice = document.querySelector(".selling-price");
    const comparePrice = document.querySelector(".compare-price");
    const discountBadges = document.querySelectorAll(".discount-badge");


    const stickyPrice = document.querySelector(".sticky-price");
    const stickyComparePrice = document.querySelector(".sticky-compare-price");

    const mobileOfferUnitPrice =
        document.querySelector(".mobile-offer-unit-price");

    const mobileOfferSaving =
        document.querySelector(".mobile-offer-saving");

    const variantCards = document.querySelectorAll(".variant-card");

    const addCartBtn = document.querySelector(".hgp-add-cart");
    const buyNowBtn = document.querySelector(".hgp-buy-now");


    function updateStockStatus(isAvailable) {

        if (isAvailable) {

            addCartBtn.disabled = false;
            buyNowBtn.disabled = false;



            addCartBtn.classList.remove("out-of-stock");
            buyNowBtn.classList.remove("out-of-stock");

        } else {

            addCartBtn.disabled = true;
            buyNowBtn.disabled = true;



            addCartBtn.classList.add("out-of-stock");
            buyNowBtn.classList.add("out-of-stock");

        }

    }

    let selectedPack = 1;

    const activeVariant =
        document.querySelector(".variant-card.active");

    let selectedSellingPrice;
    let selectedComparePrice;


    /* =========================================
       GET PACK SIZE FROM TEXT
    ========================================= */

    function getPackSize(text) {

        if (!text) return 1;

        /*
         * Look specifically for:
         * Set of 2
         * Set of 3
         * Set of 4
         * Pack of 2
         * Pack of 3
         * Pack of 4
         */

        const match = text.match(
            /(?:set|pack)\s*(?:of)?\s*(\d+)/i
        );

        if (match) {
            return Number(match[1]);
        }

        /*
         * Fallback:
         * If the title itself is simply something like
         * "Dhoop Sticks 2"
         */
        const fallback =
            text.match(/\b([234])\b/);

        return fallback
            ? Number(fallback[1])
            : 1;

    }


    /* =========================================
       VARIANT PRODUCT
    ========================================= */

    if (activeVariant) {

        selectedSellingPrice =
            Number(activeVariant.dataset.price);

        selectedComparePrice =
            Number(
                activeVariant.dataset.compare ||
                activeVariant.dataset.price
            );

        selectedPack =
            getPackSize(
                activeVariant.dataset.title
            );


    }


    /* =========================================
       SINGLE-VARIANT PRODUCT
    ========================================= */

    else {

        const sellingElement =
            document.querySelector(".selling-price");

        selectedSellingPrice =
            Number(
                sellingElement.dataset.price
            );

        selectedComparePrice =
            Number(
                sellingElement.dataset.compare ||
                sellingElement.dataset.price
            );


        /*
           Since there is no variant-card,
           detect the pack/set size from the
           product title.
        */

        selectedPack =
            getPackSize(
                document.querySelector(".hgp-title")?.textContent
            );


        /*
           If product title doesn't contain the
           pack size, also check the product
           short description.
        */

        if (selectedPack === 1) {

            selectedPack =
                getPackSize(
                    document.querySelector(
                        ".hgp-short-description"
                    )?.textContent
                );

        }

    }

    function formatMoney(value) {

        return "₹" + value.toLocaleString("en-IN");

    }

    function makePricePretty(price) {

        price = Math.round(price);

        const lastTwo = price % 100;

        // 96–99 -> make xx99
        if (lastTwo >= 96) {
            return price + (99 - lastTwo);
        }

        // 00–04 -> make previous xx99
        if (lastTwo <= 4) {
            return price - (lastTwo + 1);
        }

        return price;

    }

    function updatePricing() {
        const qty = Math.max(1, Number(qtyInput?.value) || 1);
        const packSize = Math.max(1, selectedPack || 1);
        const totalUnits = packSize * qty;

        // These are the real prices coming from Shopify Admin, in paise.
        const sellingPerPack = selectedSellingPrice / 100;
        const comparePerPack = selectedComparePrice / 100;

        // Quantity changes the total only. It never creates a new discount rate.
        const finalSelling = sellingPerPack * qty;
        const finalMRP = comparePerPack * qty;
        const saving = Math.max(0, finalMRP - finalSelling);
        const discount = comparePerPack > sellingPerPack
            ? Math.round(((comparePerPack - sellingPerPack) / comparePerPack) * 100)
            : 0;

        sellingPrice.textContent = formatMoney(Math.round(finalSelling));
        if (stickyPrice) stickyPrice.textContent = formatMoney(Math.round(finalSelling));

        if (discount > 0) {
            comparePrice.textContent = formatMoney(Math.round(finalMRP));
            if (stickyComparePrice) stickyComparePrice.textContent = formatMoney(Math.round(finalMRP));
        } else {
            comparePrice.textContent = "";
            if (stickyComparePrice) stickyComparePrice.textContent = "";
        }

        discountBadges.forEach((badge) => {
            badge.textContent = discount > 0 ? `${discount}% OFF` : "";
            badge.classList.toggle("show", discount > 0);
        });

        // Keep the unit price tied to the selected Shopify pack price.
        const unitPrice = finalSelling / totalUnits;
        const offerUnitPrice = document.querySelector(".offer-unit-price");
        const offerSavingValue = document.querySelector(".offer-saving-value");

        if (offerUnitPrice) {
            offerUnitPrice.textContent = formatMoney(Math.round(unitPrice));
        }

        if (offerSavingValue) {
            offerSavingValue.textContent = formatMoney(Math.round(saving));
        }

        if (mobileOfferUnitPrice) {
            mobileOfferUnitPrice.textContent = formatMoney(Math.round(unitPrice));
        }

        if (mobileOfferSaving) {
            mobileOfferSaving.textContent = formatMoney(Math.round(saving));
        }
    }

    variantCards.forEach(card => {

        card.addEventListener("click", () => {

            variantCards.forEach(v => v.classList.remove("active"));

            card.classList.add("active");

            selectedPack = getPackSize(card.dataset.title);

            selectedSellingPrice = Number(card.dataset.price);

            selectedComparePrice = Number(card.dataset.compare);

            updateStockStatus(
                card.dataset.available === "true"
            );

            showSlide(Number(card.dataset.imageIndex));

            updatePricing();

        });

    });

    qtyInput.addEventListener("input", () => {

        if (qtyInput.value < 1) {

            qtyInput.value = 1;

        }

        updatePricing();

    });

    minus.addEventListener("click", () => {

        setTimeout(updatePricing, 0);

    });

    plus.addEventListener("click", () => {

        setTimeout(updatePricing, 0);

    });

    updatePricing();





    if (variantCards.length) {

        updateStockStatus(
            document.querySelector(".variant-card.active")
                .dataset.available === "true"
        );

    } else {

        updateStockStatus(
            document.querySelector(".selling-price")
                .dataset.available === "true"
        );

    }



    /* =========================================================
   MOBILE / TABLET CART DRAWER
========================================================= */

    const mobileCartBar =
        document.querySelector(".hgp-mobile-cart-bar");

    const mobileAddCart =
        document.querySelector(".hgp-mobile-add-cart");

    const cartDrawer =
        document.querySelector(".hgp-cart-drawer");

    const cartDrawerOverlay =
        document.querySelector(".hgp-cart-drawer-overlay");

    const cartDrawerClose =
        document.querySelector(".hgp-cart-drawer-close");

    const drawerConfirm =
        document.querySelector(".hgp-drawer-confirm");

    const drawerQtyInput =
        document.querySelector(".drawer-qty-input");

    const drawerQtyMinus =
        document.querySelector(".drawer-qty-minus");

    const drawerQtyPlus =
        document.querySelector(".drawer-qty-plus");

    const drawerTotalPrice =
        document.querySelector(".drawer-total-price");

    const drawerPacks =
        [...document.querySelectorAll(".hgp-drawer-pack")];

    const hasVariants =
        drawerPacks.length > 0;


    /* ---------------------------------------------------------
       SELECTED VARIANT
    --------------------------------------------------------- */

    let drawerSelectedVariantId =
        hasVariants
            ? document.querySelector(
                ".hgp-drawer-pack.active"
            )?.dataset.variantId
            : document.querySelector(
                ".selling-price"
            )?.dataset.variant;


    /* =========================================================
       DRAWER PRICE CALCULATION
       SAME LOGIC AS MAIN PRODUCT PAGE
    ========================================================= */

    function getDrawerPackSize() {

        let text = "";

        if (hasVariants) {

            const selected =
                document.querySelector(
                    ".hgp-drawer-pack.active"
                );

            text =
                selected?.dataset.title || "";

        } else {

            text =
                document.querySelector(
                    ".hgp-title"
                )?.textContent || "";

            /*
             * If product title doesn't contain
             * pack size, check short description
             */
            if (!/(?:set|pack)\s*(?:of)?\s*[234]/i.test(text)) {

                text += " " +
                    (
                        document.querySelector(
                            ".hgp-short-description"
                        )?.textContent || ""
                    );

            }

        }

        const match =
            text.match(
                /(?:set|pack)\s*(?:of)?\s*(\d+)/i
            );

        if (match) {
            return Number(match[1]);
        }

        const fallback =
            text.match(/\b([234])\b/);

        return fallback
            ? Number(fallback[1])
            : 1;
    }


    /* =========================================================
       GET ORIGINAL DRAWER PRICES
    ========================================================= */

    function getDrawerOriginalPrices() {

        let selling = 0;
        let compare = 0;

        if (hasVariants) {

            const selected =
                document.querySelector(
                    ".hgp-drawer-pack.active"
                );

            selling =
                Number(
                    selected?.dataset.price || 0
                );

            compare =
                Number(
                    selected?.dataset.compare ||
                    selected?.dataset.price ||
                    0
                );

        } else {

            const sellingElement =
                document.querySelector(
                    ".selling-price"
                );

            selling =
                Number(
                    sellingElement?.dataset.price || 0
                );

            compare =
                Number(
                    sellingElement?.dataset.compare ||
                    sellingElement?.dataset.price ||
                    0
                );

        }

        return {
            selling: selling / 100,
            compare: compare / 100
        };

    }


    /* =========================================================
       UPDATE DRAWER PRICE
       SAME LOGIC AS MAIN PAGE
    ========================================================= */



    function updateDrawerTotal() {
        const qty = Math.max(1, Number(drawerQtyInput?.value) || 1);
        if (drawerQtyInput) drawerQtyInput.value = qty;

        const packSize = Math.max(1, getDrawerPackSize());
        const totalUnits = packSize * qty;
        const originalPrices = getDrawerOriginalPrices();
        const sellingPerPack = originalPrices.selling;
        const comparePerPack = originalPrices.compare;

        // Only multiply Shopify's real price. Do not calculate a quantity discount.
        const finalSelling = sellingPerPack * qty;
        const finalMRP = comparePerPack * qty;
        const saving = Math.max(0, finalMRP - finalSelling);
        const discount = comparePerPack > sellingPerPack
            ? Math.round(((comparePerPack - sellingPerPack) / comparePerPack) * 100)
            : 0;

        if (drawerTotalPrice) {
            drawerTotalPrice.textContent = `₹${Math.round(finalSelling).toLocaleString("en-IN")}`;
        }

        const drawerComparePrice = document.querySelector(".drawer-compare-price");
        if (drawerComparePrice) {
            drawerComparePrice.textContent = discount > 0
                ? `₹${Math.round(finalMRP).toLocaleString("en-IN")}`
                : "";
            drawerComparePrice.style.display = discount > 0 ? "inline" : "none";
        }

        const drawerDiscount = document.querySelector(".drawer-discount");
        if (drawerDiscount) {
            drawerDiscount.textContent = discount > 0 ? `${discount}% OFF` : "";
            drawerDiscount.style.display = discount > 0 ? "inline-flex" : "none";
        }

        const drawerUnitPrice = document.querySelector(".mobile-offer-unit-price");
        const drawerSaving = document.querySelector(".mobile-offer-saving");

        if (drawerUnitPrice) {
            drawerUnitPrice.textContent = `₹${Math.round(finalSelling / totalUnits).toLocaleString("en-IN")}`;
        }
        if (drawerSaving) {
            drawerSaving.textContent = `₹${Math.round(saving).toLocaleString("en-IN")}`;
        }
    }


    /* ---------------------------------------------------------
       OPEN
    --------------------------------------------------------- */

    function openCartDrawer() {

        if (!cartDrawer) return;

        updateDrawerTotal();

        cartDrawer.classList.add("active");

        cartDrawerOverlay?.classList.add("active");

        document.body.classList.add(
            "hgp-cart-drawer-open"
        );

    }


    /* ---------------------------------------------------------
       CLOSE
    --------------------------------------------------------- */

    function closeCartDrawer() {

        cartDrawer?.classList.remove("active");

        cartDrawerOverlay?.classList.remove("active");

        document.body.classList.remove(
            "hgp-cart-drawer-open"
        );

    }


    /* ---------------------------------------------------------
       FIXED ADD TO CART BUTTON
    --------------------------------------------------------- */

    mobileAddCart?.addEventListener(
        "click",
        () => {

            openCartDrawer();

        }
    );


    /* ---------------------------------------------------------
       CLOSE
    --------------------------------------------------------- */

    cartDrawerClose?.addEventListener(
        "click",
        closeCartDrawer
    );


    cartDrawerOverlay?.addEventListener(
        "click",
        closeCartDrawer
    );


    /* ---------------------------------------------------------
       PACK SELECTION
    --------------------------------------------------------- */

    drawerPacks.forEach(pack => {

        pack.addEventListener(
            "click",
            () => {

                if (
                    pack.dataset.available !== "true"
                ) {
                    return;
                }


                drawerPacks.forEach(
                    p =>
                        p.classList.remove(
                            "active"
                        )
                );


                pack.classList.add("active");


                drawerSelectedVariantId =
                    pack.dataset.variantId;


                updateDrawerTotal();

            }
        );

    });


    /* ---------------------------------------------------------
       QUANTITY
    --------------------------------------------------------- */

    drawerQtyMinus?.addEventListener(
        "click",
        () => {

            let qty =
                Number(drawerQtyInput.value) || 1;

            qty =
                Math.max(1, qty - 1);

            drawerQtyInput.value = qty;

            updateDrawerTotal();

        }
    );


    drawerQtyPlus?.addEventListener(
        "click",
        () => {

            let qty =
                Number(drawerQtyInput.value) || 1;

            qty += 1;

            drawerQtyInput.value = qty;

            updateDrawerTotal();

        }
    );


    drawerQtyInput?.addEventListener(
        "input",
        () => {

            if (
                Number(drawerQtyInput.value) < 1
            ) {
                drawerQtyInput.value = 1;
            }

            updateDrawerTotal();

        }
    );



    /* =========================================================
       SHOPIFY CART ADD
    ========================================================= */

    async function addSelectedProductToCart() {

        let quantity =
            Math.max(
                1,
                Number(drawerQtyInput?.value) || 1
            );

        let variantId =
            drawerSelectedVariantId;

        if (!variantId) {

            console.error(
                "No Shopify variant ID selected."
            );

            return;
        }


        /* =========================================
           BUTTON LOADING STATE
        ========================================= */

        if (drawerConfirm) {

            drawerConfirm.disabled = true;

            drawerConfirm.textContent =
                "Adding...";
 
        }

 
        try {

            const originalPrices = getDrawerOriginalPrices();
            const originalSellingPerPack = originalPrices.selling;
            const originalComparePerPack = originalPrices.compare;

            console.log("Mobile / Tablet Add To Cart:", {
                variantId,
                quantity,
                originalSellingPerPack,
                originalComparePerPack
            });


            /* =========================================
               SHOW LOADER
            ========================================= */




            /* =========================================
               ADD TO SHOPIFY CART
            ========================================= */

            const response =
                await fetch(
                    "/cart/add.js",
                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json",

                            "Accept":
                                "application/json"
                        },

                        body:
                            JSON.stringify({

                                items: [

                                    {
                                        id:
                                            Number(
                                                variantId
                                            ),

                                        quantity:
                                            quantity,

                                        /* =================================
                                           IMPORTANT
    
                                           Store the same price
                                           properties used by desktop.
                                        ================================= */

                                        

                                    }

                                ]

                            })

                    }
                );


            const data =
                await response.json();


            /* =========================================
               HANDLE ERROR
            ========================================= */

            if (!response.ok) {

                throw new Error(
                    data?.description ||
                    "Unable to add product to cart."
                );

            }


            /* =========================================
               CLOSE MOBILE / TABLET DRAWER
            ========================================= */

            closeCartDrawer();


            /* =========================================
               REFRESH + OPEN SAME DESKTOP SIDEBAR
            ========================================= */

            setTimeout(
                async () => {

                    if (
                        typeof window.openHGPCart ===
                        "function"
                    ) {

                        await window.openHGPCart();

                    } else {

                        console.warn(
                            "Main sidebar cart function is not available."
                        );

                    }

                },
                300
            );


            /* =========================================
               SUCCESS STATE
            ========================================= */

            if (mobileAddCart) {

                const originalText =
                    mobileAddCart.textContent;


                mobileAddCart.textContent =
                    "Added to Cart ✓";


                setTimeout(
                    () => {

                        mobileAddCart.textContent =
                            originalText;

                    },
                    1800
                );

            }


            /* =========================================
               CART UPDATED EVENT
            ========================================= */

            document.dispatchEvent(
                new CustomEvent(
                    "cart:updated",
                    {
                        detail: {
                            item: data
                        }
                    }
                )
            );


            /* =========================================
               REFRESH CART COUNT / OTHER UI
            ========================================= */

            try {

                const cartResponse =
                    await fetch(
                        "/cart.js"
                    );


                const cart =
                    await cartResponse.json();


                document.dispatchEvent(
                    new CustomEvent(
                        "hgp:cart-updated",
                        {
                            detail: cart
                        }
                    )
                );


            } catch (error) {

                console.warn(
                    "Cart refresh failed:",
                    error
                );

            }


        } catch (error) {

            console.error(
                "Add to cart failed:",
                error
            );


            alert(
                error.message ||
                "Something went wrong. Please try again."
            );


        } finally {




            if (drawerConfirm) {

                drawerConfirm.disabled =
                    false;

                drawerConfirm.textContent =
                    "Add to Cart";

            }

        }

    }


    drawerConfirm?.addEventListener(
        "click",
        addSelectedProductToCart
    );









    /*=========================================
      STICKY BAR
    =========================================*/

    /*=========================================
      STICKY BAR
    =========================================*/

    const stickyBar =
        document.querySelector(".hgp-sticky-bar");

    const trigger =
        document.querySelector(".product-buttons");

    function toggleSticky() {

        if (!stickyBar || !trigger) return;

        const rect = trigger.getBoundingClientRect();

        if (rect.bottom < 300) {

            stickyBar.classList.add("show");

        } else {

            stickyBar.classList.remove("show");

        }

    }

    window.addEventListener("scroll", toggleSticky);

    toggleSticky();









    const relatedSlider = document.querySelector(".related-slider");

    document.querySelector(".related-next")?.addEventListener("click", () => {

        relatedSlider.scrollBy({

            left: 250,

            behavior: "smooth"

        });

    });

    document.querySelector(".related-prev")?.addEventListener("click", () => {

        relatedSlider.scrollBy({

            left: -250,

            behavior: "smooth"

        });

    });



    const hotSlider = document.querySelector(".hot-slider");

    document.querySelector(".hot-next")?.addEventListener("click", () => {

        hotSlider.scrollBy({

            left: 250,
            behavior: "smooth"

        });

    });

    document.querySelector(".hot-prev")?.addEventListener("click", () => {

        hotSlider.scrollBy({

            left: -250,
            behavior: "smooth"

        });

    });


    /*=========================================
  CUSTOMERS ALSO LIKE NAVIGATION
=========================================*/

    const customersLikeSlider =
        document.querySelector(".customers-like-slider");


    document.querySelector(".customers-like-next")?.addEventListener("click", () => {

        customersLikeSlider?.scrollBy({

            left: 250,

            behavior: "smooth"

        });

    });


    document.querySelector(".customers-like-prev")?.addEventListener("click", () => {

        customersLikeSlider?.scrollBy({

            left: -250,

            behavior: "smooth"

        });

    });





    /*=========================================
  CUSTOMERS ALSO LIKE
=========================================*/

    async function loadCustomersAlsoLike() {

        const slider = document.querySelector(".customers-like-slider");

        if (!slider) return;

        console.log("Loading Customers Also Like...");

        try {

            const response =
                await fetch("/collections/all/products.json?limit=250");

            const data = await response.json();

            let products = data.products.filter(product =>

                product.handle !== window.location.pathname
                    .split("/")
                    .filter(Boolean)
                    .pop()

                && product.variants.some(variant => variant.available)

            );


            /* RANDOMIZE PRODUCTS */

            products.sort(() => Math.random() - 0.5);


            /* ONLY 6 PRODUCTS */

            products = products.slice(0, 10);


            slider.innerHTML = "";


            products.forEach(product => {

                const variant =
                    product.variants.find(v => v.available);

                if (!variant) return;


                const price =
                    Number(variant.price);

                const compare =
                    Number(
                        variant.compare_at_price || variant.price
                    );


                const image =
                    typeof product.images[0] === "string"
                        ? product.images[0]
                        : product.images[0]?.src || "";


                slider.innerHTML += `

                <div class="related-card">

                    <a href="/products/${product.handle}">

                        <img
                            src="${image}"
                            alt="${product.title}"
                            loading="lazy"
                        >

                    </a>


                    <div class="related-card-content">

                        <h4>
                            ${product.title}
                        </h4>


                        <div class="related-price">

                            ${compare > price
                        ? `
                                        <span class="related-compare-price">
    ₹${Math.round(compare).toLocaleString("en-IN")}
</span>
                                      `
                        : ""
                    }

                            <span class="related-selling-price">
    ₹${Math.round(price).toLocaleString("en-IN")}
</span>

                        </div>


                        <div class="related-buttons">

                            <button
                                class="related-add-cart"
                                data-variant="${variant.id}"
                                data-price="${Math.round(price * 100)}"
                                data-compare="${Math.round(compare * 100)}"
                                data-title="${product.title.replace(/"/g, '&quot;')}"
                            >
                                Add to Cart
                            </button>

                        </div>

                    </div>

                </div> 

            `;

            });


            console.log(
                "Customers Also Like loaded:",
                products.length
            );


        } catch (error) {

            console.error(
                "Customers Also Like error:",
                error
            );

        }

    }


    loadCustomersAlsoLike();







});




